export const SET_PRODUCT_COMMON_SIZE = 'SET_PRODUCT_COMMON_SIZE';

export const setProductCommonSize = (size) => {
  return {
    type: SET_PRODUCT_COMMON_SIZE,
    payload: size,
  };
};
